import TableDeleteButton from "../../../../../../../shared/components/button/TableDeleteButton";
import { DataTable } from "../../../../../../../shared/components/data-table/DataTable";
import { useTranslation } from "react-i18next";
import UpdateClientCampaignDialog from "./UpdateClientCampaignDialog";
import TableHeaderSortingButton from "../../../../../../../shared/components/button/TableHeaderSortingButton";

const ClientCampaignsTable = ({
  data,
  onCampaignEdition,
  onCampaignDeletion,
}) => {
  const { t } = useTranslation();

  const columns = [
    {
      accessorKey: "code",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.campaigns.table.code")}
          />
        );
      },
    },
    {
      accessorKey: "name",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.campaigns.table.name")}
          />
        );
      },
    },
    {
      accessorKey: "description",
      header: ({ column }) => {
        return (
          <TableHeaderSortingButton
            column={column}
            headerText={t("clients.detail.tabs.campaigns.table.description")}
          />
        );
      },
    },
    {
      id: "actions",
      cell: ({ row }) => {
        const data = row.original;
        return (
          <div className="flex flex-row justify-end pr-5">
            <UpdateClientCampaignDialog
              campaign={data}
              onSubmitHandler={(formValues) =>
                onCampaignEdition(data.id, formValues)
              }
            />
            <TableDeleteButton
              onClickHandler={() => onCampaignDeletion(data.id)}
            />
          </div>
        );
      },
    },
  ];

  return <DataTable data={data} columns={columns} />;
};

export default ClientCampaignsTable;
